/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkManualChangesResponseRecordingsInner
 */
export interface BulkManualChangesResponseRecordingsInner {
    /**
     * 
     * @type {string}
     * @memberof BulkManualChangesResponseRecordingsInner
     */
    documentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkManualChangesResponseRecordingsInner
     */
    recordingId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkManualChangesResponseRecordingsInner
     */
    hasManualChanges: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkManualChangesResponseRecordingsInner
     */
    manuallyCreated: boolean;
}

/**
 * Check if a given object implements the BulkManualChangesResponseRecordingsInner interface.
 */
export function instanceOfBulkManualChangesResponseRecordingsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "hasManualChanges" in value;
    isInstance = isInstance && "manuallyCreated" in value;

    return isInstance;
}

export function BulkManualChangesResponseRecordingsInnerFromJSON(json: any): BulkManualChangesResponseRecordingsInner {
    return BulkManualChangesResponseRecordingsInnerFromJSONTyped(json, false);
}

export function BulkManualChangesResponseRecordingsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkManualChangesResponseRecordingsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': !exists(json, 'document_id') ? undefined : json['document_id'],
        'recordingId': json['recording_id'],
        'hasManualChanges': json['hasManualChanges'],
        'manuallyCreated': json['manuallyCreated'],
    };
}

export function BulkManualChangesResponseRecordingsInnerToJSON(value?: BulkManualChangesResponseRecordingsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_id': value.documentId,
        'recording_id': value.recordingId,
        'hasManualChanges': value.hasManualChanges,
        'manuallyCreated': value.manuallyCreated,
    };
}

